import { STOPRECURRING_SUCCESS, STOPRECURRING_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const stopRecurringReducer = (state = initialState, action) => {
    switch (action.type) {
        case STOPRECURRING_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case STOPRECURRING_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default stopRecurringReducer;
